<script lang="ts">

    import type { FormInstance } from "../Model/FormInstance";
    import { sessionService } from "../Services";
    import MembersListOwner from "./MembersListOwner/MembersListOwner.svelte";
    import MembersList from "./MembersList/MembersList.svelte";
    import type { SvelteComponent } from "svelte";
    import { Icon } from "sveltestrap";

    export let instance: FormInstance;

    let partner = false;
    let listComponent: typeof SvelteComponent;

    $: setupInstance(instance);

    function setupInstance(instance: FormInstance): void {

        partner = instance.members.some(member => member.buddyId);

        if (instance.hasOwner(sessionService.user.id)) {
            listComponent = MembersListOwner;
        } else {
            listComponent = MembersList;
        }
    }

</script>

{#if partner}
    <p>En el siguiente listado pueden ver el responsable BuddyPartner (<Icon class="text-warning" name="shield-lock-fill" />) asignado: </p>     
{/if}

<svelte:component this={listComponent} {instance} />
